import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/dev/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(queryData) {
  return request({
    url: '/whg-park/api/dev/detail',
    method: 'get',
    params: queryData
  });
}
export function fetchDelete(deviceIds) {
  var data = {
    deviceIds: deviceIds
  };
  return request({
    url: '/whg-park/api/dev/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/dev/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/dev/update',
    method: 'post',
    data: data
  });
}
export function fetchSysDevTree(data) {
  return request({
    url: '/whg-park/api/dev/sysTree',
    method: 'post',
    data: data
  });
}
export function fetchFloorDevTree(data) {
  return request({
    url: '/whg-park/api/dev/partitionTree',
    method: 'post',
    data: data
  });
}
export function fetchDevTreeByClassify(data) {
  return request({
    url: '/whg-park/api/dev/selectDevTreeByClassify',
    method: 'post',
    data: data
  });
}
export function insertOrUpdateDevPosition(data) {
  return request({
    url: '/whg-park/api/dev/insertOrUpdateDevPosition',
    method: 'post',
    data: data
  });
}
export function selectDevPosition(data) {
  return request({
    url: '/whg-park/api/dev/selectDevPosition',
    method: 'post',
    data: data
  });
}